//import {CommodityValues, CommoditydataValues } from './responseFormDropDown';
export const masterJson =
  [
    {
      "fieldId": 1,
      "fieldName": "comments",
      "displayName": "Comments",
      "fieldDataType": "varchar",
      "fieldLength": 500,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'inputWithLimit',
      'dropDownData': '',
      'validationType': ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 2,
      "fieldName": "commodity",
      "displayName": "Commodity",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "SARS Harmony Codes",
      "inputType": 'input',
      'dropDownData': '',
      'validationType': ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 3,
      "fieldName": "temperature_range",
      "displayName": "Temperature Range",
      "fieldDataType": "varchar",
      "fieldLength": 10,
      "entryType": "Drop Down",
      "fieldLookup": "F_TEMP_RANGE",
      "comments": "",
      "inputType": 'dropdown',
      'dropDownData': "",
      'validationType': ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 4,
      "fieldName": "container_no",
      "displayName": "Container No.",
      "fieldDataType": "varchar",
      "fieldLength": 500,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'inputWithLimit',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 5,
      "fieldName": "container_size",
      "displayName": "Container Size",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Drop Down",
      "fieldLookup": "F_CONTAINER_SIZE",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 6,
      "fieldName": "container_category",
      "displayName": "Container Category",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Drop Down",
      "fieldLookup": "F_CONTAINER_CATEGORY",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 7,
      "fieldName": "load_units",
      "displayName": "Load Units",
      "fieldDataType": "varchar",
      "fieldLength": 10,
      "entryType": "Drop Down",
      "fieldLookup": "F_LOAD_UNIT",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 8,
      "fieldName": "destination",
      "displayName": "Destination",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'alpha'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 9,
      "fieldName": "load_kg",
      "displayName": "Load (Kg)",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 10,
      "fieldName": "no_of_containers",
      "displayName": "No. of Containers",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num',
      "requiredField": "No"
    },
    {
      "fieldId": 11,
      "fieldName": "pickup_location",
      "displayName": "Pickup Location",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'alpha'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 12,
      "fieldName": "vessel_no",
      "displayName": "Vessel No.",
      "fieldDataType": "varchar",
      "fieldLength": 15,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 13,
      "fieldName": "maximum_price",
      "displayName": "Maximum Price",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 14,
      "fieldName": "insurance_required",
      "displayName": "Insurance Required",
      "fieldDataType": "varchar",
      "fieldLength": 5,
      "entryType": "Drop Down",
      "fieldLookup": "F_YES_NO",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 15,
      "fieldName": "minimum_service_rating",
      "displayName": "Minimum Service Rating",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "Number of Stars",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    // {
    //   "fieldId": 16,
    //   "fieldName": "payment_terms",
    //   "displayName": "Payment Terms",
    //   "fieldDataType": "varchar",
    //   "fieldLength": 50,
    //   "entryType": "Drop Down",
    //   "fieldLookup": "F_PAYMENT_TERMS",
    //   "comments": "",
    //   "inputType": 'dropdown',
    //   "dropDownData": "",
    //   "validationType": ''
    //   ,
    //   "requiredField": "yes"
    // },
    {
      "fieldId": 17,
      "fieldName": "storage",
      "displayName": "Storage",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "Number of days (from date and time to Date and Time)",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'

      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 18,
      "fieldName": "truck_type_req",
      "displayName": "Truck Type Requirements",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 19,
      "fieldName": "trailer_req",
      "displayName": "Trailer Requirements",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 20,
      "fieldName": "driver_license_req",
      "displayName": "Driver License Requirements",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "Validate against DTMS categories (eNATIS)",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 21,
      "fieldName": "special_instructions",
      "displayName": "Special instructions",
      "fieldDataType": "varchar",
      "fieldLength": 500,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'inputWithLimit',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 22,
      "fieldName": "upload_documents",
      "displayName": "Upload Documents",
      "fieldDataType": "varchar",
      "fieldLength": 500,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "url of the file",
      "inputType": 'upload',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 23,
      "fieldName": "po_number",
      "displayName": "Purchase order Number",
      "fieldDataType": "varchar",
      "fieldLength": 25,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 24,
      "fieldName": "collection_point_ref",
      "displayName": "Collection Point reference",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 25,
      "fieldName": "number_of_passengers",
      "displayName": "Number of passengers",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 26,
      "fieldName": "compliance_requirements",
      "displayName": "Compliance requirements",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 27,
      "fieldName": "service_exec_flex_respo",
      "displayName": "Service Execution flexibility (respondent)",
      "fieldDataType": "date & time",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "List a drop down of the time/period in which the respondent can accommodate changes to Service Windows",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    // {
    //   "fieldId": 28,
    //   "fieldName": "rfq_closing_date_time",
    //   "displayName": "RFQ Closing Date & Time",
    //   "fieldDataType": "date & time",
    //   "fieldLength": 0,
    //   "entryType": "Free Text",
    //   "fieldLookup": "",
    //   "comments": "",
    //   "inputType": 'calendarDate',
    //   "dropDownData": '',
    //   "validationType": ''
    //   ,
    //   "requiredField": "yes"
    // },
    {
      "fieldId": 29,
      "fieldName": "cargo_packaging ",
      "displayName": "Cargo Packaging",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Drop Down",
      "fieldLookup": "F_CARGO_PACK",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 30,
      "fieldName": "cancellation_policy",
      "displayName": "Cancellation policy",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Drop Down",
      "fieldLookup": "F_CANCEL_POLICY",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 31,
      "fieldName": "dimensions",
      "displayName": "Dimensions",
      "fieldDataType": "varchar",
      "fieldLength": 10,
      "entryType": "Drop Down",
      "fieldLookup": "F_DIMENSION",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 32,
      "fieldName": "vehicles",
      "displayName": "Vehicles",
      "fieldDataType": "varchar",
      "fieldLength": 10,
      "entryType": "Drop Down",
      "fieldLookup": "F_VEHICLES",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 33,
      "fieldName": "tonnage_per_item",
      "displayName": "Tonnage per Item",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 34,
      "fieldName": "total_tonnage",
      "displayName": "Total Tonnage",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 35,
      "fieldName": "c_health_env_risks",
      "displayName": "Commodity Health/Environmental Risks",
      "fieldDataType": "varchar",
      "fieldLength": 5,
      "entryType": "Drop Down",
      "fieldLookup": "F_YES_NO",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 36,
      "fieldName": "storage_preference",
      "displayName": "Storage Preference",
      "fieldDataType": "varchar",
      "fieldLength": 10,
      "entryType": "Drop Down",
      "fieldLookup": "F_STORAGE_PREF",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 37,
      "fieldName": "vgm_preference",
      "displayName": "VGM Preference",
      "fieldDataType": "varchar",
      "fieldLength": 10,
      "entryType": "Drop Down",
      "fieldLookup": "F_VGM_PREF",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 38,
      "fieldName": "incoterms",
      "displayName": "INCOTERMS",
      "fieldDataType": "varchar",
      "fieldLength": 5,
      "entryType": "Drop Down",
      "fieldLookup": "F_INCOTERMS",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 39,
      "fieldName": "tfr_ref_number",
      "displayName": "TFR Reference Number",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 41,
      "fieldName": "status",
      "displayName": "Status",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 42,
      "fieldName": "client",
      "displayName": "Client",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 43,
      "fieldName": "full_6_meter",
      "displayName": "Full 6 meter",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Drop Down",
      "fieldLookup": "F_WEIGHT",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 44,
      "fieldName": "full_12_meter",
      "displayName": "Full 12 meter",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Drop Down",
      "fieldLookup": "F_WEIGHT",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 45,
      "fieldName": "hazmat_full_6_meter",
      "displayName": "Hazmat Full 6 meter",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Drop Down",
      "fieldLookup": "F_WEIGHT",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 46,
      "fieldName": "hazmat_full_12_meter",
      "displayName": "Hazmat Full 12 meter",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Drop Down",
      "fieldLookup": "F_WEIGHT",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 47,
      "fieldName": "un_number",
      "displayName": "UN Number",
      "fieldDataType": "number",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 48,
      "fieldName": "loading_date",
      "displayName": "Loading Date",
      "fieldDataType": "date & time",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'calendarDateTime',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 49,
      "fieldName": "railing_date",
      "displayName": "Railing Date",
      "fieldDataType": "date & time",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'calendarDateTime',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 50,
      "fieldName": "name_of_consignee",
      "displayName": "Name of consignee",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 51,
      "fieldName": "from_station_number",
      "displayName": "From Station Number",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 52,
      "fieldName": "from_terminal_number",
      "displayName": "From Terminal Number",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 53,
      "fieldName": "to_siding_number",
      "displayName": "To Siding number",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 54,
      "fieldName": "to_station_name",
      "displayName": "To Station Name",
      "fieldDataType": "varchar",
      "fieldLength": 20,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 55,
      "fieldName": "name_of_vessel",
      "displayName": "Name of Vessel",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 56,
      "fieldName": "voyage",
      "displayName": "Voyage",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 57,
      "fieldName": "name_client_agent",
      "displayName": "Name of Client/Agent",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 58,
      "fieldName": "account_number",
      "displayName": "Account Number",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": 'num'
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 59,
      "fieldName": "client_reference",
      "displayName": "Client reference",
      "fieldDataType": "varchar",
      "fieldLength": 100,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 60,
      "fieldName": "vessel_booking_reference",
      "displayName": "Vessel Booking reference",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 61,
      "fieldName": "private_siding",
      "displayName": "Private siding",
      "fieldDataType": "varchar",
      "fieldLength": 5,
      "entryType": "Drop Down",
      "fieldLookup": "F_YES_NO",
      "comments": "",
      "inputType": 'dropdown',
      "dropDownData": "",
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 62,
      "fieldName": "stack_date",
      "displayName": "Stack Date",
      "fieldDataType": "date & time",
      "fieldLength": 0,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'calendarDateTime',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 63,
      "fieldName": "intent_ref_number",
      "displayName": "Intent Reference Number",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    },
    {
      "fieldId": 64,
      "fieldName": "contact_person",
      "displayName": "Contact Person",
      "fieldDataType": "varchar",
      "fieldLength": 50,
      "entryType": "Free Text",
      "fieldLookup": "",
      "comments": "",
      "inputType": 'input',
      "dropDownData": '',
      "validationType": ''
      ,
      "requiredField": "yes"
    }
  ]